export const SearchType = {
    Chatbot: 'chatbot',
    Cases: 'cases',
} as const;
export type SearchType = (typeof SearchType)[keyof typeof SearchType];
